import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Benefit, StyledButton } from '@tryhackme/thm-ui-components';
import { Link } from 'react-router-dom';
import { usePricing } from 'src/common/hooks';
import { ReactComponent as PremiumContentImg } from 'src/images/svgs/manage-account/premium-content.min.svg';
import { StyledBenefitsWrapper, StyledInfo, StyledTitle, StyledVideoPremium } from './video-premium.styles';
export const VideoPremium = () => {
  const {
    price,
    symbol
  } = usePricing();
  return <StyledVideoPremium data-sentry-element="StyledVideoPremium" data-sentry-component="VideoPremium" data-sentry-source-file="video-premium.tsx">
      <StyledInfo data-sentry-element="StyledInfo" data-sentry-source-file="video-premium.tsx">
        <FontAwesomeIcon icon={faCircleInfo} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="video-premium.tsx" />
        <p>Subscribe to watch a walkthrough video. Otherwise, you can complete this room for free!</p>
      </StyledInfo>

      <div>
        <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="video-premium.tsx">
          Subscribe for just{' '}
          <span data-testid="video-subscription-price">
            {symbol}
            {price}
          </span>
          /month
        </StyledTitle>
        <StyledButton as={Link} to="/why-subscribe" variant="solid" color="primary" data-sentry-element="StyledButton" data-sentry-source-file="video-premium.tsx">
          Subscribe
        </StyledButton>
      </div>

      <StyledBenefitsWrapper data-sentry-element="StyledBenefitsWrapper" data-sentry-source-file="video-premium.tsx">
        <div data-testid="subscriptions-benefits">
          <Benefit text="Access to all premium learning content" data-sentry-element="Benefit" data-sentry-source-file="video-premium.tsx" />
          <Benefit text="Get your own browser-based Kali Machine" data-sentry-element="Benefit" data-sentry-source-file="video-premium.tsx" />
          <Benefit text="Enroll in all learning paths" data-sentry-element="Benefit" data-sentry-source-file="video-premium.tsx" />
          <Benefit text="Private OpenVPN servers" data-sentry-element="Benefit" data-sentry-source-file="video-premium.tsx" />
          <Benefit text="Start machines faster" data-sentry-element="Benefit" data-sentry-source-file="video-premium.tsx" />
        </div>
        <PremiumContentImg height={155} data-sentry-element="PremiumContentImg" data-sentry-source-file="video-premium.tsx" />
      </StyledBenefitsWrapper>
    </StyledVideoPremium>;
};